<template>
  <div>
    <div class="grid-content bg-purple-light">
      <el-calendar :value="value" id="calendar"  :ShowNextPrevMonth="false">
        <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法  @click="Select"-->
        <template slot="dateCell" slot-scope="{date, data}">
          <!--自定义内容  style="width:85px; height:55px;text-align:center;"   @click="Select"-->
          <div>
            <div class="calendar-day" >{{ data.day.split('-').slice(1).join('-') }}{{ data.isSelected ? '✔️' : ''}}</div>
            <div v-for="(item,index) in calendarData" :key="index">
              <div v-if="(item.workDate==data.day)">
                <el-popover
                    placement="top-start"
                    width="240"
                    trigger="hover">
                    <div>工作时长:{{item.wTime}}<br/>上班打卡时间:{{item.onDuty==null?'未打卡':item.onDuty}}<br/>下班打卡时间:{{item.offDuty==null?'未打卡':item.offDuty}}</div>
                    <div slot="reference" :class="item.status =='异常'|| item.status==' 休息日打卡 '?'is_notnormal': 'is-selected' ">{{item.status}}</div>
                  </el-popover>
                <!-- <el-tooltip class="item" effect="dark" :content="item.things" placement="right"> title="标题"-->
                  <!-- <el-popover
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    content="工作时长：9 上班打卡时间：2020/6/1 8:26:19 下班打卡时间：2020/6/1 18:02:27">
                  <div slot="reference" :class="item.status =='异常'|| item.status==' 休息日打卡 '?'is_notnormal': 'is-selected' ">{{item.status}}</div>
                  </el-popover> -->
                <!-- </el-tooltip> -->
              </div>
              <div v-else></div>
            </div>
          </div>
        </template>
      </el-calendar>
    </div>
    <!-- <div class="bottom_detail">
      <el-row>
        <div>
          <label style="float:left">工作时长:</label>
          <span style="color:#1989FA;float:left">{{wTime}}</span>
          <label style="float:left">小时</label>
        </div>
      </el-row>
      <el-row>
        <div>
          <label style="float:left">上班打卡时间:</label>
          <span style="color:#1989FA;float:left">{{onDuty}}</span>
        </div>
      </el-row>
      <el-row>
        <div>
          <label style="float:left">下班打卡时间:</label>
          <span style="color:#1989FA;float:left;height:25px">{{offDuty}}</span>
        </div>
      </el-row>
    </div> -->
  </div>
</template>
<script>
import $ from "jquery";
import { Decrypt } from "../until/ZeusApiSDK/Logic/CryptoLogic";
import { GeteUserBaseList } from "../until/ZeusApiSDK/Logic/StructureLogic";
import { GeteAttendanceList,GeteAttendanceSummary,GetAttendanceDay,GetAttendanceDayOnePc,GetHomeAttendanceDay } from "../until/ZeusApiSDK/Logic/AttendanceListLogic";

export default {
  props:{
    value:{
      type:Date,
      default:()=>new Date
    }
  },
  data() {
    return {
      DataName: {}, //考勤汇总
      chModelList: [], //考勤汇总
      chModelList1: [], //考勤汇总
      model: {}, //考勤汇总
      list: [], //每天打卡详情
      onDuty: "", //上班打卡时间
      offDuty: "", //下班打卡时间
      wTime: "", //工作时长
      currentUser: {}, //当前登录用户信息
      userBase: {}, //用户基本信息
      AttendanceList: {}, //考勤数据
      AttendanceSummary: {}, //考勤汇总
      input: "",
      activeName: "first",
      calendarData: [],
      joinValue: "",
    }
  },
  methods:{
    open() {
      this.$alert("没有当前月的汇总数据", "", {
        confirmButtonText: "确定"
      });
    },
    // Select(tab, event) {
    //   this.joinValue = new Date().getFullYear() + "-" + tab.toElement.outerText;
    //   //   console.log(tab);
    //   this.geteAttendance();
    //   // this.getAttendanceDayOnePc(tab.toElement.outerText); //绑定每天的打卡数据
    // },
    geteAttendance: async function() {
      if (this.joinValue == "" || this.joinValue == null) {
        this.joinValue = this.value.toDateString();
      }
      var data = {
        //datetimes:this.value.toDateString(),
        datetimes: this.joinValue,
        name: this.currentUser.TrueName,
        userCode: this.currentUser.UserCode
      };
      await GetHomeAttendanceDay(data).then(res => {
        if(res.list.length<=0){
          var nowDate=new Date();
          var year=nowDate.getFullYear();
          var lastMonth=nowDate.getMonth()<10?'0'+nowDate.getMonth():nowDate.getMonth();
          var lastDay=nowDate.getDate()<10?'0'+nowDate.getDate():nowDate.getDate();
          data = {
            //datetimes:this.value.toDateString(),
            datetimes: year+'-'+lastMonth+'-'+lastDay,
            name: this.currentUser.TrueName,
            userCode: this.currentUser.UserCode
          };
          GetHomeAttendanceDay(data).then(res=>{
            res.list.forEach(item => {
              item.workDate=item.workDate.split(' ')[0];
            });
            this.calendarData = res.list;
            this.list = res.list;
          });
        }
        else{
          res.list.forEach(item => {
            item.workDate=item.workDate.split(' ')[0];
          });
          this.calendarData = res.list;
          this.list = res.list;
        }
      });

      // GetAttendanceDay(data).then(res=>{
      //   console.log('页面颞部信息',res);
      //   this.calendarData = res.listCalendarData;
      // })
    },
    //获取当前用户
    getCurrentUser: function() {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    //获取当前用户信息
    getUserInfo: function() {
      //构造参数
      var predicates = [
        {
          Field: "UserID",
          Value: this.currentUser.UserId,
          Oper: "eq",
          IsAnd: 1
        }
      ];
      //获取userBase基本信息
      GeteUserBaseList(predicates).then(res => {
        if (res.length > 0) {
          this.userBase = res[0];
        }
      });
    }
  },
  created(){
    //获取当前用户
    this.getCurrentUser();
    //获取当前用户信息
    this.getUserInfo();
    //获取考勤日历
    this.geteAttendance();
    
  },
  mounted(){
    $(".el-calendar__button-group").css("display",'none');
  }
}
</script>
<style scoped lang="less">
.calendar-day {
  text-align: center;
  color: #202535;
  line-height: 30px;
  font-size: 12px;
}
.is-selected {
  color: #1989fa;
}
.is_notnormal {
  color: red;
}
.bottom_detail {
  float: left;
  margin-left: 20px;
}
.el-calendar__button-group{
  display:none;
}
</style>
